import { createAction, props } from '@ngrx/store';

export enum AppConfigActions {
  AppConfigLoaded = '[App Config] Loaded internal',
}

export const appConfigLoaded = createAction(
  AppConfigActions.AppConfigLoaded,
  props<{
    appConfig: any;
  }>(),
);
